module.exports = __webpack_public_path__ + "static/media/18-days-voyage.6b992087.jpg";